import './page.css';
import projects from '../data/3dassetprojects.json'

function AssetProject(project){
	const title = project.title;
	const photo = project.photo;

	function HoverButton(e){
		e.target.style.background ="rgb(255, 169, 255)"
		e.target.style.color = "black"
		e.target.style.cursor = "pointer";
	}

	function LeaveButton(e){
		e.target.style.background = '#3f3f3f'
		e.target.style.color = "white"
	}

	return(
		title ?
		<div className='card card-gallery card-column'>
			<a href={`./images/${photo}`} target="_blank" title="Make image larger in new tab" >
				<img src = {`./images/${photo}`} className='img'></img>
			</a>
			<p>{title}</p>
		</div>
		: null
	)
}

export default function AssetProjects () {
	
	return(
		<>
		<h1 className='headline pads'>3D Asset Projects Gallery - {projects.length} Pictures</h1>
		<div className='cards card-grid pads'>
			{projects.map(project =>(
				<AssetProject {...project}/>
			))
			}
		</div>
		</>
	)
}